module.exports = __webpack_public_path__ + "68a7fc5afc4ff432c3895c8fa70029b6.svg";